import { OptionType } from 'spa/member/components/Select/types'

const WorkPreferenceFormNames = {
  CurrentSituation: 'work-preference-current-situation-form',
  DesiredProject: 'work-preference-desired-project-form',
  Skills: 'work-preference-skills-form',
  Others: 'work-preference-others-form'
} as const

const workDaysOfWeekOptions = [
  { name: 'work_days_of_week', label: '月', value: '0', type: 'normal' },
  { name: 'work_days_of_week', label: '火', value: '1', type: 'normal' },
  { name: 'work_days_of_week', label: '水', value: '2', type: 'normal' },
  { name: 'work_days_of_week', label: '木', value: '3', type: 'normal' },
  { name: 'work_days_of_week', label: '金', value: '4', type: 'normal' },
  { name: 'work_days_of_week', label: '土', value: '5', type: 'normal' },
  { name: 'work_days_of_week', label: '日', value: '6', type: 'normal' },
  { name: 'work_days_of_week', label: '曜日をすべて選択', resetLabel: '曜日をすべて解除', value: 'all', type: 'all' },
]

const officeDaysOfWeekOptions = [
  { name: 'office_days_of_week', label: '月', value: '0', type: 'normal' },
  { name: 'office_days_of_week', label: '火', value: '1', type: 'normal' },
  { name: 'office_days_of_week', label: '水', value: '2', type: 'normal' },
  { name: 'office_days_of_week', label: '木', value: '3', type: 'normal' },
  { name: 'office_days_of_week', label: '金', value: '4', type: 'normal' },
  { name: 'office_days_of_week', label: '土', value: '5', type: 'normal' },
  { name: 'office_days_of_week', label: '日', value: '6', type: 'normal' },
  { name: 'office_days_of_week', label: 'なし', value: '7', type: 'reset' },
  { name: 'office_days_of_week', label: '曜日をすべて選択', resetLabel: '曜日をすべて解除', value: 'all', type: 'all' },
]

const desiredWorkStyleOptions = [
  { name: 'desired_work_styles', label: 'フルリモート', value: 'remote_work', type: 'normal' },
  { name: 'desired_work_styles', label: '一部リモート', value: 'partial_remote_work', type: 'normal' },
  { name: 'desired_work_styles', label: '常駐', value: 'office_work', type: 'normal' },
]

const FULL_REMOTE_WORK_STYLE = 'remote_work'
const FULLY_REMOTE_PREFERENCE = 'fully_remote'
const OFFICE_DAYS_OF_WEEK_NONE_VALUE = '7'

const remoteWorkPreferenceOptions = [
  { label: '固定でなければ必要に応じて出社の相談も可能', value: 'flexible' },
  { label: 'オンボーディング期間や初日は出社可能', value: 'onboarding_only' },
  { label: '出社は完全に不可能', value: 'fully_remote' },
]

const availableTimeOptions = [
  { label: '平日日中', value: 'weekday_daytime' },
  { label: '基本は平日夜間/土日だが平日日中のミーティングは可能', value: 'evening_or_weekend_mtg_flexible' },
  { label: '平日夜間/土日のみ', value: 'evening_or_weekend' },
]

const wishBooleanOptions = [
  { label: '希望する', value: 'true' },
  { label: '希望しない', value: 'false' },
]

const workFromAbroadOptions = [
  { label: '国内(日本)で稼働予定', value: 'false' },
  { label: '国外(日本以外)で稼働予定', value: 'true' },
]

export {
  WorkPreferenceFormNames,
  workDaysOfWeekOptions,
  officeDaysOfWeekOptions,
  desiredWorkStyleOptions,
  FULL_REMOTE_WORK_STYLE,
  FULLY_REMOTE_PREFERENCE,
  OFFICE_DAYS_OF_WEEK_NONE_VALUE,
  remoteWorkPreferenceOptions,
  availableTimeOptions,
  wishBooleanOptions,
  workFromAbroadOptions
}
